import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class CrossIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 20 20"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path
					d="M 3.5,1 L 10,7.5 16.5,1 19,3.5 12.5,10 19,16.5 16.5,19 10,12.5 3.5,19 1,16.5 7.5,10 1,3.5 3.5,1 Z"
					style={{
						fill: this.props.color,
						stroke: "#000000",
						fillOpacity: 0.5,
						strokeWidth: 1,
						strokeOpacity: 1
					}}/>
			</svg>
		);
	}
}